<template>
  <div>
    <span v-if="apiError">
      {{ $t('APPS.LIST.API_ERROR') }}
    </span>

    <div v-else-if="apps.length" class="table-responsive">
      <table class="table table--hover">
        <colgroup>
          <col class="hidden-apps-table__first-col" />
          <col class="hidden-apps-table__second-col" />
          <col class="hidden-apps-table__third-col" />
        </colgroup>
        <thead>
          <tr>
            <th>{{ $t('APPS.LIST.NAME') }}</th>
            <th>{{ $t('APPS.LIST.STATUS') }}</th>
            <th />
          </tr>
        </thead>
        <tbody>
          <tr v-for="(app, index) in apps" :key="index">
            <td class="hidden-apps-table__first-col">
              {{ app.name }}
            </td>
            <td>{{ getAppState(app.publishedBeforeHide) }}</td>
            <td>
              <ElButton
                :disabled="!hasPublish(app.packageName)"
                type="primary"
                @click="unhide(app.packageName)"
              >
                {{ $t('APPS.HIDDEN_APPS.UNHIDE') }}
              </ElButton>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <span v-else>
      {{ $t('APPS.LIST.NO_DATA') }}
    </span>

    <ElPagination
      v-if="apps.length"
      class="el-pagination--block"
      :current-page="currentPage"
      layout="prev, pager, next"
      :total="hiddenApps.length"
      @current-change="setCurrentPage"
    />
  </div>
</template>

<script>
import { PublishActions } from '@/api/api';

import form from '@/mixins/form';
import modal from '@/mixins/modal';
import permissions from '@/mixins/permissions';
import appState from '@/mixins/appState';

export default {
  name: 'HiddenApps',

  mixins: [modal, form, permissions, appState],

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    hiddenApps: {
      type: Array,
      default() {
        return [];
      },
    },
    apiError: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      currentPage: 1,
      pageSize: 10,
    };
  },

  computed: {
    apps() {
      const offsetStart = this.pageSize * (this.currentPage - 1);
      const offsetEnd = offsetStart + this.pageSize;

      return this.hiddenApps.slice(offsetStart, offsetEnd);
    },
  },

  methods: {
    setCurrentPage(page) {
      this.currentPage = page;
    },

    unhide(packageName) {
      return PublishActions.unhide({ packageName }, {})
        .then(({ body: { message } }) => {
          this.$message.success(message);

          const refreshApps = true;
          this.$emit('close', refreshApps);
        })
        .catch(({ body: { message } = {} }) => {
          if (message) {
            this.$message.error(message);
          }
        });
    },
  },
};
</script>

<style lang="scss">
.hidden-apps-table {
  $second-col-width: 125px;
  $third-col-width: 200px;

  table-layout: fixed;

  &__first-col {
    width: calc(100% - #{$second-col-width} + #{$third-col-width});
    white-space: normal !important;
  }

  &__second-col {
    width: $second-col-width;
  }

  &__third-col {
    width: $third-col-width;
  }
}
</style>
